export default class Newsletter {

  constructor(el) {
    this.el = el
    this.form = el.querySelector('form.newsletter--form')
    if (!this.form) return

    this.mailer = this.form.dataset.mailer

    this.bindCheckboxes()
    this.bindSubmit()
  }

  bindCheckboxes() {
    this.el.querySelectorAll('.footer--checkbox-container').forEach(container => {
      container.addEventListener('click', (e) => {
        const checkbox = container.querySelector('.footer--input-checkbox')
        if (e.target !== checkbox) {
          checkbox.checked = !checkbox.checked
        }
      })
    })
  }

  bindSubmit() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()

      const amispam = this.form.querySelector('#amispam')
      if (amispam && amispam.value) {
        console.error('Oh no ! I m Spam')
        return
      }

      const formData = new FormData(this.form)

      this.setState('loading')

      fetch(this.mailer, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok')
          return response
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.setState('sent')
          setTimeout(() => {
            this.setState('submit')
            this.form.reset()
          }, 5000)
        })
    })

    this.form.querySelectorAll('.newsletter--submit.is-loading, .newsletter--submit.is-sent').forEach(btn => {
      btn.addEventListener('click', e => e.preventDefault())
    })
  }

  setState(state) {
    this.form.querySelectorAll('.newsletter--submit').forEach(btn => btn.classList.remove('is-active'))
    const target = this.form.querySelector(`.newsletter--submit.is-${state}`)
    if (target) target.classList.add('is-active')
  }

}
